import { gql } from "@apollo/client";

export const UPDATE_USER_TIMEZONE = gql`
  mutation updateUserTimezone($timezone: String) {
    updateUserTimezone(timezone: $timezone) {
      name
      timezone
      createdAt
      updatedAt
    }
  }
`;

export const GET_USER_INFO = gql`
  query getUserInfo {
    user {
      name
      timezone
      organization
      telegram
      phone
      email
      sendMail
      createdAt
      updatedAt
      passwordUpdatedAt
    }
  }
`;

export const GET_INTERCOM_INFO = gql`
  query getUserIntercomJWT {
    getUserIntercomJWT
  }
`;

export const GET_MY_PRICING = gql`
  query GetMyPricing {
    getMyPricing {
      GOOGLE_STORE {
        id
        REVIEWS
        RATINGS
        KEYWORDS
        KEYWORDS_PRO
        DIRECT
        VISIT
      }
      APP_STORE {
        id
        REVIEWS
        RATINGS
        KEYWORDS
        KEYWORDS_PRO
        DIRECT
        VISIT
      }
    }
  }
`;

export const GET_MY_FULL_PRICING = gql`
  query getMyFullPricing {
    getMyFullPricing {
      STARTER {
        GOOGLE_STORE {
          id
          REVIEWS
          RATINGS
          KEYWORDS
          KEYWORDS_PRO
          DIRECT
          VISIT
        }
        APP_STORE {
          id
          REVIEWS
          RATINGS
          KEYWORDS
          KEYWORDS_PRO
          DIRECT
          VISIT
        }
      }
      ADVANCED {
        GOOGLE_STORE {
          id
          REVIEWS
          RATINGS
          KEYWORDS
          KEYWORDS_PRO
          DIRECT
          VISIT
        }
        APP_STORE {
          id
          REVIEWS
          RATINGS
          KEYWORDS
          KEYWORDS_PRO
          DIRECT
          VISIT
        }
      }
      EXPERT {
        GOOGLE_STORE {
          id
          REVIEWS
          RATINGS
          KEYWORDS
          KEYWORDS_PRO
          DIRECT
          VISIT
        }
        APP_STORE {
          id
          REVIEWS
          RATINGS
          KEYWORDS
          KEYWORDS_PRO
          DIRECT
          VISIT
        }
      }
      CUSTOM {
        GOOGLE_STORE {
          id
          REVIEWS
          RATINGS
          KEYWORDS
          KEYWORDS_PRO
          DIRECT
          VISIT
        }
        APP_STORE {
          id
          REVIEWS
          RATINGS
          KEYWORDS
          KEYWORDS_PRO
          DIRECT
          VISIT
        }
      }
    }
  }
`;

// total amount of spent money
export const GET_ACCOUNT_SPENDINGS = gql`
  query getLevelInfo {
    accountLevelInfo {
      totalSpendings
      discount
      connectedAppsCount
      trackedKeywordsCount
    }
  }
`;

export const GET_TIMEZONE_INFO = gql`
  query timezoneInfo {
    getProfileTimezone {
      timezone
      localTime
      email
      name
    }
  }
`;

// The link in a letter: public, the token names the recipient. These are
// mutations on the backend, which is why the old query form never worked.
export const UNSUBSCRIBE_FROM_MAIL_BY_TOKEN = gql`
  mutation unsubscribeFromMailByToken($token: String!) {
    unsubscribeFromMailByToken(token: $token)
  }
`;

export const RESUBSCRIBE_TO_MAIL_BY_TOKEN = gql`
  mutation resubscribeToMailByToken($token: String!) {
    resubscribeToMailByToken(token: $token)
  }
`;

export const GET_USER_TIMEZONE = gql`
  query timezone {
    getProfileTimezone {
      timezone
    }
  }
`;

export const GET_USER_REFERRAL_LINK = gql`
  query referralLink {
    user {
      referallLink
    }
  }
`;

export const GET_USER_REFERRAL_BALANCE = gql`
  query referralBalance {
    user {
      activeBonuses
      allTimeBonuses
    }
  }
`;

export const UPDATE_USER = gql`
  mutation updateUser($userData: UpdateUser) {
    updateUser(userData: $userData) {
      name
      timezone
      organization
      telegram
      phone
      email
      sendMail
      createdAt
      updatedAt
      passwordUpdatedAt
    }
  }
`;

export const GET_USER_FAVOURITE_COUNTRIES = gql`
  query getUserFavouriteCountries {
    user {
      id
      favouriteCountries
      __typename
    }
  }
`;

export const GET_USER_NOTIFICATIONS = gql`
  query getUserNotifications {
    getUserNotifications {
      id
      message
      type
      created_at
      isViewed
    }
  }
`;

export const UPDATE_SEEN_NOTIFICATIONS = gql`
  mutation updateSeenNotifications($notificationIds: [Int!]) {
    updateSeenNotifications(notificationIds: $notificationIds) {
      id
      isViewed
    }
  }
`;

export const ONBOARD_USER = gql`
  mutation onboardUser($onboardData: Onboarding!) {
    onboardUser(onboardData: $onboardData) {
      email
    }
  }
`;

export const GET_USER_RESTRICTIONS = gql`
  query getUserRestrictions {
    getUserRestrictions {
      applications
      keywords
      keywordsLimit
      applicationsLimit
      profileLevel
    }
  }
`;

export const GET_USER_KEYWORDS_BY_APP_ID_AND_GEO = gql`
  query getUserKeywordsByAppIDAndGeo($appId: String, $store: Store) {
    getUserKeywordsByAppIDAndGeo(appId: $appId, store: $store)
  }
`;
